import { Component, Input, OnInit } from '@angular/core';
import { finalize } from 'rxjs';
import { TaskNoteService } from '../../../../../../services/task-note.service';
import { TaskNoteTypes } from 'app/models/enums/TaskNoteTypes';

@Component({
  selector: 'app-components-specialist-actioncomponents-page-optimization-shared-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class PageOptimizationNotesComponent implements OnInit {
  @Input() customer: Boo.Objects.Customer;
  @Input() taskId: number;
  @Input() currentNoteType: TaskNoteTypes;
  @Input() workflowId: number;

  isLoading = true;
  recentNote: PageOptimizationNote = null;
  allOtherNotes: PageOptimizationNote[] = [];

  constructor(private taskNoteService: TaskNoteService) { }

  ngOnInit(): void {
    this.taskNoteService.getByWorkflowId(this.workflowId)
      .pipe(
        finalize(() => this.isLoading = false)
      )
      .subscribe({
        next: (workflowNotes) => {
          const notes = workflowNotes
            .filter(x => !(x.TaskId === this.taskId && x.TaskNoteTypeId === this.currentNoteType))
            .sort((a, b) => new Date(b.InsertedDate).getTime() - new Date(a.InsertedDate).getTime())
            .map(x => ({
              author: this.getAuthor(x.TaskNoteTypeId, x.FromUserFullName),
              date: x.InsertedDate,
              note: x.Note,
              title: this.getTitle(x.TaskNoteTypeId),
              type: x.TaskNoteTypeId
            }));

          this.recentNote = notes[0] && notes[0].type != this.currentNoteType ? notes[0] : null;

          this.allOtherNotes = notes.filter(x => x != this.recentNote);
        },
        error: (err) => toastr.error('Failed to load history:', err)
      });
  }

  private readonly titleMap: Record<number, string> = {
    [TaskNoteTypes.Unlock]: 'Task Unlocked',
    [TaskNoteTypes.WorkblockReason]: 'Workblock',
    [TaskNoteTypes.WorkblockResolution]: 'Workblock Resolved',
    [TaskNoteTypes.ContentFeedback]: 'Content Feedback',
    [TaskNoteTypes.ImplementationFeedback]: 'Implementation Feedback',
    [TaskNoteTypes.NoteForContentReviewer]: 'Note for Content Reviewer',
    [TaskNoteTypes.NoteForImplementationReviewer]: 'Note for Implementation Reviewer',
    [TaskNoteTypes.CustomerFeedback]: 'Customer Feedback'
  };

  private getAuthor(type: TaskNoteTypes, originalAuthor: string): string {
    switch (type) {
      case TaskNoteTypes.CustomerFeedback:
        return `${this.customer.Name} - Customer`;
  
      default:
        return originalAuthor;
    }
  }
  
  private getTitle(type: Boo.Objects.Enums.TaskNoteTypes): string {
    return this.titleMap[type] ?? 'Note';
  }
}

export interface PageOptimizationNote {
  note: string;
  date: Date;
  author: string;
  type: TaskNoteTypes;
  title: string;
}
